export default __webpack_public_path__ + "static/media/46.5a025b7d.jpg";